module.exports = __webpack_public_path__ + "img/playNext.e9569fe6.svg";